import React, { useState, useEffect } from 'react';
import { Container, Jumbotron } from 'reactstrap';
import { useQuery } from '@apollo/react-hooks';
import { GET_VERSIONS } from '../../query/query';
import history from '../../router/history';
import LoveboxInfo from './lovebox-info';
import MultiSearchBar from './multi-search-bar';
import { LoveboxList } from '../sav-lovebox/form/lovebox-list';
import TransferBoxHistory from './transfer-box-history';
import CheckColorCode from './check-color-code';
import BatchColor from './batch-color';

const LoveboxInfoPage = ({
  match: {
    params: {
      email: emailProp = '',
      box,
      macAddress: macAddressProp = '',
      pairing: pairingProp = '',
    },
  },
  isLoveboxBatchManager,
}) => {
  const [email, setEmail] = useState(emailProp);
  const [macAddress, setMacAddress] = useState(macAddressProp);
  const [pairing, setPairing] = useState(pairingProp);
  const [selectedLovebox, setSelectedLovebox] = useState('');
  const [urlBoxId, setUrlBoxId] = useState(box);
  const [versions, setVersions] = useState({});
  const {
    data: { savGetVersions } = {},
  } = useQuery(GET_VERSIONS);

  useEffect(() => {
    if (savGetVersions) setVersions(savGetVersions);
  }, [savGetVersions]);

  const handleSearchByEmail = (newEmail) => {
    if (newEmail) {
      history.push({
        pathname: `/lovebox/${newEmail}`,
      });
      setEmail(newEmail);
      setSelectedLovebox('');
      setUrlBoxId('');
      setMacAddress('');
      setPairing('');
    }
  };

  const handleSelectedBoxChange = (id) => {
    const idUrl = id.substring(0, 5);
    history.push({
      pathname: `/lovebox/${email}/${idUrl}`,
    });
    setUrlBoxId(idUrl);
    setSelectedLovebox(id);
    setMacAddress('');
    setPairing('');
  };

  const handleSearchByMacAddress = (newMacAddress) => {
    history.push({
      pathname: `/lovebox/macAddress/${newMacAddress}`,
    });
    setMacAddress(newMacAddress);
    setEmail('');
    setSelectedLovebox('');
    setUrlBoxId('');
    setPairing('');
  };

  const handleSearchByPairing = (newPairing) => {
    history.push({
      pathname: `/lovebox/pairing/${newPairing}`,
    });
    setPairing(newPairing);
    setEmail('');
    setSelectedLovebox('');
    setUrlBoxId('');
    setMacAddress('');
  };

  const handleSearch = ({ email: newEmail, macAddress: newMacAddress, pairing: newPairing }) => {
    if (newEmail) {
      handleSearchByEmail(newEmail);
    } else if (newMacAddress) {
      handleSearchByMacAddress(newMacAddress);
    } else if (newPairing) {
      handleSearchByPairing(newPairing);
    }
  };

  return (
    <Container>
      <Jumbotron>
        <h3>
          Lovebox info
        </h3>
        <hr className="my-2" />

        <MultiSearchBar
          macAddress={macAddress}
          pairing={pairing}
          email={email}
          versions={versions}
          onSearch={handleSearch}
        />
        {email
         && (
         <LoveboxList
           email={email}
           onSelectedBoxChange={handleSelectedBoxChange}
           urlBoxId={urlBoxId}
         />
         )}
        {(macAddress || pairing || selectedLovebox)
        && (
          <LoveboxInfo
            pairing={pairing}
            versions={versions}
            macAddress={macAddress}
            boxId={selectedLovebox}
          />
        )}
      </Jumbotron>
      <Jumbotron>
        <h3>Transfer box history</h3>
        <hr className="my-2" />
        <TransferBoxHistory />
      </Jumbotron>

      <Jumbotron>
        <h3>Check Color Code</h3>
        <hr className="my-2" />
        <CheckColorCode />
      </Jumbotron>

      {isLoveboxBatchManager && (
        <Jumbotron>
          <h3>Batch B&W / Color</h3>
          <hr className="my-2" />
          <BatchColor />
        </Jumbotron>
      )}
    </Container>
  );
};

export default LoveboxInfoPage;



// WEBPACK FOOTER //
// ./src/components/lovebox-info/lovebox-info-page.js